import $ from 'jquery'
import contabilidad24 from '../img/contabilidad24.png';
import Presentacion2 from '../img/Presentacion2.png';
import facturacion from '../img/facturacion.png';
import almacen from '../img/almacen2.png';
import Presentacion1 from '../img/Presentacion1.png';

$(document).ready(function () {
    
    // contabilidad

    $('#contabilidad-productos').click(function(){
        $('#contabilidad-productos').css('backgroundColor', '#0791f3');
        $('#contabilidad-parrafo').css('color', 'white');

        $('.imagen-productos').attr('src',contabilidad24);
        $('.parrafo-producto').text('El módulo de contabilidad es útil para la generación de informes y análisis del sistema');

        $('#ventas-productos').css('backgroundColor', 'white');
        $('#ventas-parrafo').css('color', '#999');

        $('#reporte-productos').css('backgroundColor', 'white');
        $('#reporte-parrafo').css('color', '#999');
        
        $('#almacen-productos').css('backgroundColor', 'white');
        $('#almacen-parrafo').css('color', '#999');
        
        $('#facturacion-productos').css('backgroundColor', 'white');
        $('#facturacion-parrafo').css('color', '#999');
    });


    //ventas 
    $('#ventas-productos').click(function () { 
        $('#ventas-productos').css('backgroundColor', '#0791f3');
        $('#ventas-parrafo').css('color', 'white');

        $('.imagen-productos').attr('src',Presentacion2);
        $('.parrafo-producto').text('Control de cotización, pedidos, guiado y emisión de comprobantes');

        $('#contabilidad-productos').css('backgroundColor', 'white');
        $('#contabilidad-parrafo').css('color', '#999');
        
        $('#reporte-productos').css('backgroundColor', 'white');
        $('#reporte-parrafo').css('color', '#999');
        
        $('#almacen-productos').css('backgroundColor', 'white');
        $('#almacen-parrafo').css('color', '#999');

        $('#facturacion-productos').css('backgroundColor', 'white');
        $('#facturacion-parrafo').css('color', '#999');

    });

    // facturacion
    $('#facturacion-productos').click(function () { 
        $('#facturacion-productos').css('backgroundColor', '#0791f3');
        $('#facturacion-parrafo').css('color', 'white');

        $('.imagen-productos').attr('src',facturacion);
        $('.parrafo-producto').text('Manejamos Facturación manual y electronica, confie en Noi systems.');

        $('#ventas-productos').css('backgroundColor', 'white');
        $('#ventas-parrafo').css('color', '#999');

        $('#contabilidad-productos').css('backgroundColor', 'white');
        $('#contabilidad-parrafo').css('color', '#999');
        
        $('#reporte-productos').css('backgroundColor', 'white');
        $('#reporte-parrafo').css('color', '#999');

        $('#almacen-productos').css('backgroundColor', 'white');
        $('#almacen-parrafo').css('color', '#999');
    });

    // almacen
    $('#almacen-productos').click(function () { 
        $('#almacen-productos').css('backgroundColor', '#0791f3');
        $('#almacen-parrafo').css('color', 'white');

        $('.imagen-productos').attr('src',almacen);
        $('.parrafo-producto').text('Controla tus almacenes y ubicaciones. Noi Systems gestionará tu inventario.');

        $('#facturacion-productos').css('backgroundColor', 'white');
        $('#facturacion-parrafo').css('color', '#999');

        $('#ventas-productos').css('backgroundColor', 'white');
        $('#ventas-parrafo').css('color', '#999');

        $('#contabilidad-productos').css('backgroundColor', 'white');
        $('#contabilidad-parrafo').css('color', '#999');

        $('#reporte-productos').css('backgroundColor', 'white');
        $('#reporte-parrafo').css('color', '#999');
        
    });

    //reporte

    $('#reporte-productos').click(function () { 
        $('#reporte-productos').css('backgroundColor', '#0791f3');
        $('#reporte-parrafo').css('color', 'white');

        $('.imagen-productos').attr('src',Presentacion1);
        $('.parrafo-producto').text('Los reportes son emitidos en formato Excel,pdf y vista previa.');

        $('#almacen-productos').css('backgroundColor', 'white');
        $('#almacen-parrafo').css('color', '#999');

        $('#facturacion-productos').css('backgroundColor', 'white');
        $('#facturacion-parrafo').css('color', '#999');

        $('#ventas-productos').css('backgroundColor', 'white');
        $('#ventas-parrafo').css('color', '#999');

        $('#contabilidad-productos').css('backgroundColor', 'white');
        $('#contabilidad-parrafo').css('color', '#999');
        
    });





});


// WEBPACK FOOTER //
// ./src/js/EventoProductos.js